import React, { useEffect } from 'react';
import {
  Box, Grid, IconButton, Tooltip,
} from '@mui/material';
import NumberFormatContext from 'components/CustomInputsInFormikContext/NumberFormat';
import AddIcon from '@mui/icons-material/Add';
import { ReactComponent as Trash } from 'images/icons/trash.svg';
import { useFormikContext } from 'formik';
import { calculateTotalPrice } from './helpers';
import api from 'services/api';
import UnitOfMeasurement from 'components/UnitOfMeasurement';
import AutoCompleteContext from 'components/CustomInputsInFormikContext/AutoComplete';
import { useParams } from 'react-router-dom';
import { labelField } from 'utils';

function InputGroup({
  index, onRemove, onAdd, unities, supplies, setUnities,
}) {
  const {
    getFieldProps, getFieldMeta, setFieldValue, setFieldTouched,
  } = useFormikContext();

  const { id } = useParams();

  const { value: items } = getFieldProps('items');
  const fieldMeta = getFieldMeta(`items.${index}.unity`);

  const item = items[index];

  const disabledField = id;

  useEffect(() => {
    async function load() {
      try {
        if (!item.supply) return;
        const correlatedUnities = await api.get(
          `/unities/correlated/${item.supply.stock.unity.id}`,
        );
        setUnities(correlatedUnities.data);
      } catch (error) {
        throw new Error();
      }
    }
    load();
  }, [item.supply, setUnities]);

  return (
    <Box display="flex" width="100%" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={2.4}>
          <AutoCompleteContext
            disabled={disabledField}
            label={labelField('Insumo')}
            name={`items.${index}.supply`}
            options={supplies}
            onChangeCallback={(value) => {
              setFieldValue(`items.${index}.unity`, value.stock.unity);
            }}
            getOptionLabel={(option) => `${option.name}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2.4}>
          <UnitOfMeasurement
            disabled={disabledField}
            labelTextField={labelField('Unidade')}
            selectedUnity={item.unity}
            autoCompleteOptions={unities}
            onChange={(_, newValue) => {
              setFieldValue(`items.${index}.unity`, newValue);
            }}
            onBlur={() => setFieldTouched(`items.${index}.unity`, true)}
            error={fieldMeta.touched && fieldMeta.error}
            helperText={fieldMeta.touched && fieldMeta.error}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={2.4}>
          <NumberFormatContext
            disabled={disabledField}
            fieldSize={20}
            label={labelField('Quantidade')}
            name={`items.${index}.quantity`}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={2.4}>
          <NumberFormatContext
            disabled={disabledField}
            fieldSize={20}
            label={labelField('Preço Unitário')}
            name={`items.${index}.price`}
            prefix="R$ "
            decimalScale={2}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={2.4}>
          <NumberFormatContext
            fieldSize={20}
            label="Preço Total"
            name={`items.${index}.total`}
            value={calculateTotalPrice(item)}
            decimalScale={2}
            prefix="R$ "
            disabled
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs="auto"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        {index > 0 && (
          <Tooltip title="Remover">
            <IconButton
              disabled={disabledField}
              sx={{ bgcolor: '#FFDAD6' }}
              size="large"
              onClick={onRemove}
            >
              <Trash style={{ width: 14, height: 14, color: '#B3261E' }} />
            </IconButton>
          </Tooltip>
        )}

        {index === 0 && (
          <Tooltip title="Adicionar">
            <IconButton
              disabled={disabledField}
              sx={{ bgcolor: '#DBE5DE' }}
              onClick={onAdd}
            >
              <AddIcon sx={{ color: '#006E2D' }} />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Box>
  );
}

export default InputGroup;
